export const COOKIES = {
  pincode: 'pincode',
  legacy: 'legacy',
};
